import { DataLayer } from '@shared/types/data-layer';
import { TrackingImpression } from '@shared/types/tracking';

export interface State {
    data: DataLayer;
    impression: TrackingImpression[];
}

export const initialState: State = {
    data: null,
    impression: [],
};
